import React, { useState, useEffect } from 'react';
import { sortByNumber, sortList } from '../../lib/functions';

const SelectCustomerSnapShot = ({ fetchReports, warehouseCustomers, customers, theme }) => {
    const [error, setError] = useState('');
    const [customer, setCustomer] = useState('');

    const isLightTheme = theme === 'light';

    // on mount sort by id then create unique set of companies
    const uniqueCompanies = React.useMemo(() => {
        if (customers && customers.length > 0) {
            const sortedCustomers = sortByNumber(customers, 'id');
            const uniqueSet = new Set();
            const uniqueList = sortedCustomers.filter(c => {
                if (uniqueSet.has(c.company)) {
                    return false;
                } else {
                    uniqueSet.add(c.company);
                    return true;
                }
            });
            const uniqueSorted = sortList(uniqueList, 'company');
            return uniqueSorted;
        }
        return [];
    }, [customers]);

    // Handle form submission
    const handleSubmit = () => {
        if (!customer) {
            setError('Please select customer!');
            return;
        }
        setError('');
        const reportData = {
            id: customer,
        }
        // const selectedDate = `${year}-${month}`;
        fetchReports(reportData); // Trigger the fetch function
    };

    return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap:10,
                justifyContent: 'center',
                alignItems: 'center', // Ensures vertical centering
                margin: '20px auto', // Centers the div horizontally
                padding: '40px',
                width: '100%', // Adjusts width to fit content
                border: '2px solid',
                borderRadius: '10px',
                minHeight: '290px', // Ensures a minimum height
            }}>
                
                <h2>Warehouse SnapShots</h2>

                {/* Select dropdown for customer */}
                <select
                    value={customer}
                    onChange={(e) => setCustomer(e.target.value)}
                    style={{ 
                        padding: '5px', 
                        textAlign: 'center',
                        backgroundColor: isLightTheme ? '#fff' : '#333',
                        color: isLightTheme ? '#333' : '#fff',
                        border: `1px solid ${isLightTheme ? '#ccc' : '#555'}`,
                        borderRadius: '3px',
                        width: '100%'
                    }}
                >
                    <option value="">Customer To SnapShot</option>
                    {uniqueCompanies.map((customerObj, index) => (
                        <option key={index} value={customerObj.id}>
                            {customerObj.company}
                        </option>
                        ))}
                </select>

                {/* Select dropdown for route */}
                {/* <select
                    value={route}
                    onChange={(e) => setRoute(e.target.value)}
                    style={{ padding: '5px', textAlign: 'center' }}
                >
                    <option value="">All Routes</option>
                    {routesList.map((r, index) => (
                        <option key={index} value={r}>
                            {r}
                        </option>
                        ))}
                </select> */}

                {/* Select dropdown for month
                <select
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    style={{ padding: '5px', textAlign: 'center' }}
                >
                    <option value="">Month</option>
                    {Array.from({ length: 12 }, (_, index) => {
                        const value = (index + 1).toString().padStart(2, '0');
                        return (
                            <option key={value} value={value}>
                                {new Date(0, index).toLocaleString('default', { month: 'long' })}
                            </option>
                        );
                    })}
                </select>

                {/* Select dropdown for year */}
                {/* <select
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    style={{ padding: '5px', textAlign: 'center' }}
                >
                    <option value="">Year</option>
                    {Array.from({ length: 10 }, (_, index) => {
                        const value = new Date().getFullYear() - index;
                        return (
                            <option key={value} value={value}>
                                {value}
                            </option>
                        );
                    })}
                </select> */}

                {/* Submit button */}
                <button
                    className="hoverable"
                    onClick={handleSubmit}
                    style={{
                        padding: '5px 10px',
                        width: '100%',
                        backgroundColor: '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Submit
                </button>

            {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        </div>
    );
};

export default SelectCustomerSnapShot;
